import { instagramDarkGradientImage, instagramImage, instagramStoryImage } from '@anytag/shared-assets';
import { IconType, SocialIconConfigType, Variant } from './types';

const defaultVariantConfigs = {
  white: { variant: 'white' },
  gray: { variant: 'gray' }
} satisfies Partial<Record<Variant, IconType>>;

export const socialIconConfigs: SocialIconConfigType = {
  INSTAGRAM: {
    icon: 'instagram',
    variant: {
      ...defaultVariantConfigs,
      original: { src: instagramImage },
      transform: { src: instagramDarkGradientImage }
    }
  },
  INSTAGRAM_STORY: {
    icon: 'instagram-story',
    variant: { ...defaultVariantConfigs, original: { src: instagramStoryImage } }
  },
  YOUTUBE: {
    icon: 'youtube',
    variant: { ...defaultVariantConfigs, original: { variant: 'red' } }
  },
  FACEBOOK: {
    icon: 'facebook',
    variant: {
      ...defaultVariantConfigs,
      original: { variant: 'blue' },
      transform: { icon: 'facebook-transform', variant: 'blue' }
    }
  },
  TWITTER: {
    icon: 'x-logo',
    variant: { ...defaultVariantConfigs, original: { variant: 'black' } }
  },
  TIKTOK: {
    icon: 'tiktok',
    variant: { ...defaultVariantConfigs, original: { icon: 'tiktok-colors' }, transform: { icon: 'tiktok-transform' } }
  },
  // We still have state 'white' and 'gray' for threads, currently we don't have UI case or design yet. Will update later
  THREADS: {
    icon: 'threads',
    variant: { ...defaultVariantConfigs, original: { variant: 'black' }, transform: { icon: 'threads-transform' } } // threads-transform not used yet, we can replace later
  },
  DOUYIN: {
    icon: 'douyin',
    variant: { ...defaultVariantConfigs }
  },
  XHS: {
    icon: 'xiaohongshu',
    variant: { ...defaultVariantConfigs, original: { variant: 'red' } }
  }
};
